import { memo, useCallback } from "react"
import { useWholesalerArticleItemState } from "../../ContextProviderStates/WholesalerArticleItemState"
import { ArticleContainer, ArticleWrapper } from "../Default/DefaultArticleItem"
import { TileArticleContentComponent } from "./TileArticleContent"
import { WholesalerArticleContent } from "./WholesalerArticleContent"

export const WholesalerArticleItem = memo(() => {
    const tileView = useWholesalerArticleItemState((x) => x.options.tileView)

    const renderContent = useCallback(() => {
        if (tileView) {
            return <TileArticleContentComponent />
        }
        return <WholesalerArticleContent />
    }, [tileView])

    return (
        <ArticleWrapper>
            <ArticleContainer tileView={tileView}>{renderContent()}</ArticleContainer>
        </ArticleWrapper>
    )
})
